import React from 'react';
// import { Link } from "gatsby"
// import Layout from "../components/Layout/layout";
// import * as Styled from "../styles/pages/contactStyles";
import SEO from "../components/seo";
import Gallery from "../components/IndexPage/Gallery/gallery";
// import Maps from "../components/Maps/maps";

const gallery = () => {
 
    return (
        <>
        <SEO title="Gallery" />
        <Gallery />

        </>
    );
};

export default gallery;

